import { Flex, Skeleton, Spacer, Text } from '@chakra-ui/react'

import { ProgressBar } from '@/components/ui'

import { ProgressBarIProps } from './ProgressBar'

interface ProgressBarLabelIProps extends ProgressBarIProps {
  label: string
  rightLabel: string
  value: number
  isLoading: boolean
}

export const ProgressBarLabel = ({
  label,
  rightLabel,
  value,
  isLoading,
  barColour = 'brand.250',
  barBgColour = 'bg.550',
  ...rest
}: ProgressBarLabelIProps) => {
  return (
    <Flex flexDir='column' mt='8px' width='100%'>
      <Skeleton isLoaded={!isLoading}>
        <Flex flexDir='row' width='100%'>
          <Text color='bg.600' fontSize='12px' fontWeight={500}>
            {label}
          </Text>
          <Spacer />
          <Text color='bg.600' fontSize='12px' fontWeight={500}>
            {rightLabel}
          </Text>
        </Flex>

        <ProgressBar
          barBgColour={barBgColour}
          barColour={barColour}
          value={value}
          {...rest}
        />
      </Skeleton>
    </Flex>
  )
}
